export const fieldsName = {
  timeZone: 'timeZone',
  scheduleDate: 'scheduleDate',
  scheduleTime: 'scheduleTime',
};
